import script from "./TempO.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempO.vue?vue&type=script&lang=ts&setup=true"

import "./TempO.vue?vue&type=style&index=0&id=bc764878&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc764878"]])

export default __exports__